import Vue from 'vue';
import VueMask from 'v-mask';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
 

window.Vue = require('vue').default;
Vue.component('v-select', vSelect);

Vue.component('insured', require('./components/ims/Insured.vue').default);
Vue.component('policy-print', require('./components/ims/PolicyPrint.vue').default);
Vue.component('login-page', require('./components/ims/Login.vue').default);
Vue.component('basicclientprofile-page', require('./components/ims/BasicClientProfile.vue').default);
Vue.component('basicclientprofilelist-page', require('./components/ims/BasicClientProfileList.vue').default);
Vue.component('advanceclientprofile-page', require('./components/ims/AdvanceClientProfile.vue').default);
Vue.component('advanceclientprofilelist-page', require('./components/ims/AdvanceClientProfileList.vue').default);
Vue.component('individualclientprint-page', require('./components/ims/IndividualClientPrint.vue').default);
Vue.component('benificialownership-page', require('./components/ims/BenificialOwnership.vue').default);
Vue.component('customerriskprofiling-page', require('./components/ims/CustomerRiskProfiling.vue').default);
Vue.component('advanced-profile', require('./components/ims/IndividualProfile.vue').default);
Vue.component('advanced-corporate-profile', require('./components/ims/CorporateProfile.vue').default);
Vue.component('corporateclient-print', require('./components/ims/CorporateClientPrint.vue').default);
Vue.component('corporateclient-print', require('./components/ims/CorporateClientPrint.vue').default);
Vue.component('advancecorporateclient-profile', require('./components/ims/AdvanceCorporateClientProfile.vue').default);
Vue.component('kyc-dashboard', require('./components/ims/KycDashboard.vue').default);
Vue.component('client_details', require('./components/ims/Clientdetails.vue').default);
Vue.component('client-report', require('./components/ims/ClientReport.vue').default);
Vue.component('client-print', require('./components/ims/ClientReportPrint.vue').default);
Vue.component('client-summary', require('./components/ims/ClientSummary.vue').default);
Vue.component('client-summaryprint', require('./components/ims/ClientSummaryPrint.vue').default);
Vue.component('advanceclientsearch-page', require('./components/ims/ClientAdvanceSearch.vue').default);
Vue.component('blockaccountsclient-page', require('./components/ims/BlockAccountsClient.vue').default);
Vue.component('blockaccountsclientlist-page', require('./components/ims/BlockAccountsClientList.vue').default);
Vue.component('blockaccountsclientimport-page', require('./components/ims/BlockAccountsClientImport.vue').default);
Vue.component('matchingbulkclient-page', require('./components/ims/MatchingBulkClient.vue').default);
Vue.component('country-page', require('./components/ims/Country.vue').default);
Vue.component('province-page', require('./components/ims/Province.vue').default);
Vue.component('city-page', require('./components/ims/City.vue').default);
Vue.component('countrylist-page', require('./components/ims/CountryList.vue').default);
Vue.component('provincelist-page', require('./components/ims/ProvinceList.vue').default);
Vue.component('citylist-page', require('./components/ims/CityList.vue').default);
Vue.component('cdcshareholderimport-page', require('./components/ims/CDCShareHolderImport.vue').default);
Vue.component('cdcshareholderlist-page', require('./components/ims/CDCShareHolderList.vue').default);










Vue.use(VueMask);

const app = new Vue({
  el: '#app',
});



// WEBPACK FOOTER //
// ./src/main.js